module.exports = __webpack_public_path__ + "fonts/opMlgY43.woff2";